import { render, staticRenderFns } from "./CalculateSo.vue?vue&type=template&id=d525b388&"
import script from "./CalculateSo.vue?vue&type=script&lang=js&"
export * from "./CalculateSo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports